import { ProgressType } from 'types';
import { TemplateAction } from '../../action-types';
import { VideoTemplateStateContent } from '../../types';
import {
  setProgress,
  setProgressAlignment,
  setProgressSize,
  setProgressType,
} from './mutations';

export default function reducer(
  state: VideoTemplateStateContent,
  action: TemplateAction,
): VideoTemplateStateContent {
  switch (action.type) {
    case 'PROGRESS_CHANGE':
      return setProgress(state, action.payload);

    case 'PROGRESS_TYPE_CHANGE':
      return setProgressType(state, action.payload);

    case 'PROGRESS_ALIGNMENT_CHANGE':
      return setProgressAlignment(state, action.payload);

    case 'PROGRESS_SIZE_CHANGE':
      return setProgressSize(state, action.payload);

    case 'CHILD_VIEW_OPEN': {
      if (action.payload === 'progress' && !state.progress.enabled) {
        return setProgressType(state, ProgressType.BAR);
      }
      return state;
    }

    default:
      return state;
  }
}
